import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { QRCodeSVG } from "qrcode.react";
import { api } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";
import { usePrintReady } from "@/lib/print";

const css = `@page { size: 62mm 40mm; margin: 0; } @media print { .no-print { display: none !important; } body { background: #fff !important; } }
.etq { width: 62mm; height: 40mm; box-sizing: border-box; padding: 2.5mm; display: flex; gap: 2.5mm; align-items: center; background: #fff; color: #000; font-family: Arial, sans-serif; margin: 0 auto; border: 1px dashed #bbb; }
@media print { .etq { border: 0; } }`;

export default function QrLabel() {
  const { id } = useParams();
  const { user } = useAuth();
  const [d, setD] = useState(null);
  useEffect(() => {
    Promise.all([api.get(`/orders/${id}`), api.get(`/orders/${id}/public-link`)])
      .then(([o, l]) => setD({ order: o.data, url: l.data.url })).catch(() => setD({ error: true }));
  }, [id]);
  usePrintReady(!d ? "loading" : d.error ? "error" : "ready", "OS não encontrada para a etiqueta");
  if (!d) return <div className="p-6 text-sm">Carregando…</div>;
  if (d.error) return <div className="p-6 text-sm">Não encontrado.</div>;
  const shops = user?.shops || [];
  const shopName = shops.find((s) => s.id === d.order.shop_id)?.name || user?.shop?.name || "Oficina";
  return (
    <div className="min-h-screen bg-white py-4">
      <style>{css}</style>
      <div className="no-print text-center mb-3"><button data-testid="label-print-btn" onClick={() => window.print()} className="px-4 py-2 bg-black text-white rounded text-sm font-bold">Imprimir</button></div>
      <div className="etq" data-testid="qr-label">
        <QRCodeSVG value={d.url} size={128} style={{ width: "33mm", height: "33mm", flexShrink: 0 }} />
        <div style={{ minWidth: 0 }}>
          <div style={{ fontFamily: "monospace", fontWeight: 900, fontSize: 17, letterSpacing: 1 }}>{d.order.vehicle?.plate}</div>
          {d.order.order_number && <div style={{ fontSize: 9, marginTop: 2 }}>OS #{d.order.order_number}</div>}
          <div style={{ fontSize: 10, fontWeight: 700, marginTop: 4, lineHeight: 1.15 }}>{shopName}</div>
          <div style={{ fontSize: 8, marginTop: 3, lineHeight: 1.2 }}>Aponte a câmera e acompanhe o serviço</div>
        </div>
      </div>
    </div>
  );
}
